import React, { Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../store/ducks/solicitacoesRetorno/actions';
import { Button, Card, List, Tag } from 'antd';
import CardSecMobile from '../CardSecMobile';
import { CloseCircleOutlined, WarningOutlined, PrinterOutlined } from '@ant-design/icons';
import ModalAtendimentoSaida from '../Modal';

import { ButtonsStyle, RowLine, SpanBlock } from './styles';
import { maskCurrency, maskDate, maskUnd } from '../../../../utils/mask';
import ModalTransportadora from '../ModalTransportadora';

const CardMobile: React.FC<any> = ({
  props,
  loading,
  inscricaoAtiva,
  cddAtivo,
  filter,
  confirmarCancelarPedido,
  handlePdf,
  pagination,
}) => {
  const dispatch = useDispatch<Dispatch<Action>>();

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };
  const getStatusName = (text: string) => {
    let data;
    let color;
    switch (text) {
      case 'SL':
        data = 'SOLICITADO';
        color = 'blue';
        break;
      case 'PC':
        data = 'PEDIDO CONFIRMADO';
        color = 'lime';
        break;
      case 'AG':
        data = 'AGENDADO';
        color = 'orange';
        break;
      case 'EM':
        data = 'NOTA EMITIDA';
        color = 'cyan';
        break;
      case 'EX':
        data = 'EXPEDIDO';
        color = 'green';
        break;
      default:
        data = '';
        break;
    }

    return data === '' ? (
      ''
    ) : (
      <Tag style={{ textTransform: 'uppercase' }} color={color}>
        {data}
      </Tag>
    );
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.nuNota}>
            <ButtonsStyle>
              <Button
                onClick={() => handlePdf(item.nuNota)}
                type="ghost"
                block
                className="primary"
                icon={<PrinterOutlined />}
              >
                Imprimir
              </Button>
              <Button
                onClick={() => confirmarCancelarPedido(item.nuNota)}
                danger
                type="text"
                className="primary"
                block
                icon={<CloseCircleOutlined />}
                disabled={item.status === 'SL' ? false : true}
              >
                Cancelar Pedido
              </Button>
              <Button block className="primary" type="ghost" icon={<WarningOutlined />} disabled>
                Registrar Ocorrência
              </Button>

              {/*<ModalTransportadora codParceiro={item.nuNota} />*/}
            </ButtonsStyle>
            <RowLine>
              <p>
                <strong>N° da solicitação</strong>
                <SpanBlock>
                  <ModalAtendimentoSaida
                    text={item.nuNota}
                    nuNota={item.nuNota}
                    chave={item.chaveNfe}
                  />
                </SpanBlock>
              </p>
              <p>
                <strong>N° do pedido</strong>
                <SpanBlock>
                  {item.numNota === 0 ? 'Pedido não confirmado ' : item.numNota}
                </SpanBlock>
              </p>
              <p>
                <strong>N° da nota</strong>
                <SpanBlock>{item.numpedido === 0 ? 'Nota não emitida' : item.numpedido}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Data solicitação</strong>{' '}
                <SpanBlock>{maskDate(item.dtSolicitacao)}</SpanBlock>
              </p>
              <p>
                <strong>Pagador</strong> <SpanBlock>{item.pagador}</SpanBlock>
              </p>
              <p>
                <strong>Depositante</strong> <SpanBlock>{item.parceiro}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Status</strong>
                <SpanBlock>{getStatusName(item.status)}</SpanBlock>
              </p>
              <p>
                <strong>Peso bruto</strong>
                <SpanBlock>{item.peso > 0 ? maskUnd(item.peso) + ' KG' : '0'}</SpanBlock>
              </p>
              <p>
                <strong>Valor da mercadoria</strong>
                <SpanBlock>
                  {item.valor === 0 ? 'Nota não emitida' : maskCurrency(item.valor)}
                </SpanBlock>
              </p>
            </RowLine>
            <CardSecMobile nuNota={item.nuNota} props={item} />
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
